import type { Settings } from 'CoreApi.Settings_V12';
import type { Address } from 'Common/types';
import { Subscription } from 'CommonAPI';

export enum TssProvisionState {
  Active = 'INITIALIZED',
  InProgress = 'UNINITIALIZED',
  NotActive = 'DISABLED',
  Deleted = 'DELETED',
  Defective = 'DEFECTIVE',
  NoTSS = 'No TSS created',
}

export interface Device {
  id: string;
  name: string;
  client: string | null;
}

export type SaveSettingsPayload = Pick<
  Partial<Settings>,
  'store_name' | 'tax_number' | 'vat_number'
> & {
  billing_address?: Partial<Address>;
  shipping_address?: Partial<Address>;
};

export interface TARExport {
  id: string;
  request_date: string;
  start_date: string;
  end_date: string | null;
  state: string;
  eta: string | null;
  expires_on: string | null;
  tss_id: string | null;
}

export interface TARExportPayload {
  start_date: string;
  end_date: string;
}

export interface TSSExportPayload {
  next: string | null;
  previous: string | null;
  results: Array<TARExport>;
}

export interface TSSDevice {
  tss_id: string;
  state: string;
  description: string;
  clients: string[];
  created_at: string;
  client: string;
  serial_number: string;
  software: string;
  manufacturer: string;
  model: string;
  bsi_certification_id: string;
}

export interface TSSDevicesPayload {
  tss_ids: Array<TSSDevice>;
}

export interface TSSDeviceDetailPayload {
  uuid: string;
  tss_id: string;
  state: string | null;
  client: string;
  last_usage: string;
  fiskal_service_enabled: boolean;
  name: string;
}

export interface FiscalizationCheckResponse {
  can_use_ksv_v2: boolean;
  provisioning_state: TssProvisionState;
  start_date: string | null;
}

export interface ClientDataList {
  next: string | null;
  previous: string | null;
  results: ClientData[];
}

export interface ClientData {
  id: string;
  acquisition_date: string | null;
  commissioning_date: string | null;
  decommissioning_date: string | null;
  decommissioning_reason: string | null;
  model: string | null;
  remarks: string | null;
  serial_number: string;
  software: string;
  manufacturer: string;
  bsi_certification_id: string;
}

export interface Organization {
  uuid: string;
  plan_name: string;
}

export type FormattedDate = string;

export interface AccountData {
  id: number;
  tss_ids: TSSDevice[];
  subscriptions: Subscription[];
  organizations: Organization[];
  created_at: FormattedDate;
  inv_id: number;
  data: any;
  email: string;
  organization_id: string;
  fiskal_service_enabled: boolean;
  can_use_ksv_v2: boolean;
  user: number;
  eas_serial_number: string;
  eas_software_version: string;
}

export type KsvActivationStatus = 'success' | 'activate' | null;
